import { Controller } from '@hotwired/stimulus';

// FIXME: このコントローラを使用している箇所は
//        form helper の date_field に置換可能
export default class extends Controller {
  connect() {
    const $element = $(this.element);
    $element.daterangepicker({
      autoUpdateInput: false,
      linkedCalendars: false,
      locale: {
        daysOfWeek: ['日', '月', '火', '水', '木', '金', '土'],
        format: 'YYYY.MM.DD',
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
      },
      singleDatePicker: true,
    });
    $element.on('apply.daterangepicker', (ev, picker) => {
      $element.val(picker.startDate.format('YYYY.MM.DD'));
    });
  }
}
